import { useGlobalState } from "@/Providers";

export const LICENSE_ID_MAX_FLOORS_PER_LIFT = 33;
export const LICENSE_ID_MAX_IO_PER_LIFT = 34;

export const getLicenseLimit = (attributeId: number): number => {
    const { buildInfo } = useGlobalState() ?? {};
    const licensedAttributes = buildInfo?.highestLimitsLicensedAttributes ?? [];
    return licensedAttributes.find(attribute => attribute.attributeId === attributeId)?.licenseLimit ?? 0;
};
